import { useEffect, useState } from "react"
import { disconnectSignalR, initializeWithFallback } from "../services/signalRService"

export function useSignalRConnection(userId: string | undefined) {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function connect() {
      const success = await initializeWithFallback(userId);
      if (mounted) setConnected(success);
    }
    connect();
    return () => {
      mounted = false;
      disconnectSignalR();
    };
  }, [userId]);

  return connected;
}
